



























































































import { Vue, Component, Prop } from 'vue-property-decorator'
@Component({})
export default class ShareMod extends Vue {
  @Prop() current
  @Prop() last
  @Prop() babyUrl
  @Prop() babyName
  levelList: object[] = [
    {
      title: 'PreK',
      color: '#FF9799',
      img: require('../img/pre1.png'),
    },
    {
      title: 'K',
      color: '#FFB25A',
      img: require('../img/pre2.png'),
    },
    {
      title: '1',
      color: '#FFCF25',
      img: require('../img/level1.png'),
    },
    {
      title: '2',
      color: '#C0E502',
      img: require('../img/level2.png'),
    },
    {
      title: '3',
      color: '#83EB6B',
      img: require('../img/level3.png'),
    },
    {
      title: '4',
      color: '#5AEAD5',
      img: require('../img/level4.png'),
    },
    {
      title: '5',
      color: '#5BCCFB',
      img: require('../img/level5.png'),
    },
    {
      title: '6',
      color: '#5EAFF8',
      img: require('../img/level6.png'),
    },
    {
      title: '6+',
      color: '#AB8FFC',
      img: require('../img/level7.png'),
    },
  ]
  // 根据蓝思值返回对应等级
  get getLevel() {
    const map = [
      {
        label: 'PreK',
        value: [-2000, 0],
        dec:
          '恭喜你完成了测评！你已经认识了英文字母和少量高频词汇，还能在有图片提示的情况下，识别出故事中的不同角色。真的很棒哟，继续加油啦！',
      },
      {
        label: 'K',
        value: [1, 150],
        dec:
          '恭喜你完成了测评！你已经能识别大多数高频词汇，识别出故事中的不同角色，还能区分一些简单的文本类型啦。真了不起。继续加油啦！',
      },
      {
        label: '1',
        value: [151, 420],
        dec:
          '恭喜你完成了测评！你现在是位初级阅读达人啦。你掌握了大量基础词汇，真厉害。你还能复述文章中的一些内容，记忆力和理解能力也是棒棒的哟。继续加油啦！',
      },
      {
        label: '2',
        value: [421, 620],
        dec:
          '恭喜你完成了测评！你现在是位中级阅读达人啦。你可以自己提问并且问答一些信息类问题咯，比如：故事主人公是谁？故事发生在什么时候？你的阅读理解能力很不错，继续加油啦！',
      },
      {
        label: '3',
        value: [621, 740],
        dec:
          '恭喜你完成了测评！你现在是位中级阅读达人啦。你对文章的理解更加深刻了呢。在阅读过程中，你能关注到文章的主线或故事的情节发展，还能相对完整地复述文章。这可不是一般人可以做到的哟。继续加油！',
      },
      {
        label: '4',
        value: [741, 870],
        dec:
          '恭喜你完成了测评！你现在是位阅读达人啦。你不仅能读懂文章，还能分析文章了哟。在阅读过程中，你开始关注文章的观点和细节描述。能在阅读后，明确说明文章的观点并利用文章中的细节（如人物语言，动作描述），深入描述角色和事件。继续加油啦！',
      },
      {
        label: '5',
        value: [871, 950],
        dec:
          '恭喜你完成了测评！你现在已经是一位阅读达人了哟。普通的阅读内容已经难不倒你啦。你可以阅读故事、戏剧、诗歌等中高等难度的作品。能明确说明文章的观点，利用文章中的细节，比较故事或戏剧文本中不同的角色和事件，还能理解文章中使用的大部分单词及短语含义，包括修辞语言。太厉害了！继续加油啦！',
      },
      {
        label: '6',
        value: [951, 1010],
        dec:
          '恭喜你完成了测评！你现在已经是一位阅读达人了哟。普通的阅读内容对你来说已经是小菜一碟。你不仅能完全掌握文章观点，理解文章中的单词和短语含义，还能逐步比较故事、戏剧和诗歌等不同文本的表现形式。阅读能力一级棒！继续加油！',
      },
      {
        label: '6+',
        value: [1011, 2000],
        dec:
          '恭喜你完成了测评！你现在已经是位阅读大神啦。任何阅读内容，对你来说都轻而易举。你可以明确文本的主题，分析复杂的人物角色，了解作者如何安排文章的结构以及一些细节处理，还能理解作者的用词和语气处理的用意。保持住你的最佳阅读状态吧，继续加油！',
      },
    ]
    let currentScore = this.current.score.b_new
    const currentValue = map.find(
      item => currentScore >= item.value[0] && currentScore <= item.value[1]
    )
    if (this.last) {
      let lastScore = this.last.score.b_new
      const lastValue = map.find(
        item => lastScore >= item.value[0] && lastScore <= item.value[1]
      )
      return [currentValue, lastValue]
    } else {
      return [currentValue]
    }
  }
  // 处理时间只要年月日
  get getTime() {
    let value = this.current.create_time
    let index = value.indexOf(' ')
    let time = value.substring(0, index)
    return time
  }
  // 转换蓝思值负号为BR
  changeScore(value) {
    if (value < 0) {
      return 'BR' + -value
    } else {
      return value
    }
  }
  // 跳转链接
  toPath(path) {
    this.$router.push(`/reimsAssess/${path}?_hideShareButton=1`)
  }
}
